// The CloudFederationClient seam (contracts.md registry row "CloudFederationClient seam"; ADR-0016).
//
// Federation-first (external-services.md:42, D22/D26): Nightcrew registers as a trusted identity and
// holds NO standing key to a customer's cloud. `offer` probes support, `establishFederation` records
// the right to assume a short-lived role, and `mintScopedToken` is the fallback that returns a
// plaintext token EXACTLY ONCE - the caller vaults it via SecretsVault.store then DISCARDS the
// plaintext; it is never a column and never logged (00-architecture invariant 4). Types + schemas
// only here; the fixture lands in @nightcrew/connections (Wave 2), real behind
// `connections.real_cloud_federation`.
import { z } from "zod";
import { Cloud } from "../model/enums.js";
import { NonEmptyString } from "../model/common.js";
/**
 * A capability a scoped cloud token may carry. A narrow, closed set - the crew's build/deploy job
 * needs no more. Minimal by intent; widen only through an ADR.
 */
export const CloudCapability = z.enum(["deploy", "read_state", "read_logs"]);
/** The scope a minted cloud token is bounded to: one cloud, one region, a narrow capability list. */
export const CloudScope = z.strictObject({
    cloud: Cloud,
    region: NonEmptyString,
    capabilities: z.array(CloudCapability).readonly(),
});
//# sourceMappingURL=cloud-federation.js.map